import React from "react";
import { Link } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { useLocation } from "react-router-dom";
import {
  useUpdateUserData,
  useUserData,
} from "components/customHooks/userDataContext";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import AddToQueueIcon from "@material-ui/icons/AddToQueue";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AssessmentIcon from "@material-ui/icons/Assessment";
import HelpIcon from "@material-ui/icons/Help";
import SettingsIcon from "@material-ui/icons/Settings";
import EventIcon from "@material-ui/icons/Event";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import SearchIcon from "@material-ui/icons/Search";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
// import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupIcon from "@material-ui/icons/Group";
import EventNoteIcon from "@material-ui/icons/EventNote";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import MicIcon from "@material-ui/icons/Mic";
import { logout } from "apiHandler/actions";
import ChecklistIcon from "@mui/icons-material/Checklist";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import PersonIcon from "@mui/icons-material/Person";
import InsightsIcon from "@mui/icons-material/Insights";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import {
  AutoFixHigh,
  Chat,
  Description,
  History,
  Receipt,
  Summarize,
  VolunteerActivismOutlined,
} from "@mui/icons-material";
import AssignmentIcon from "@mui/icons-material/Assignment";

const callingNavigation = [
  {
    to: "/call-dashboard-new",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "DASHBOARD NEW*",
  },
  {
    to: "/call-dashboard",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "DASHBOARD ",
  },
  {
    to: "/call-settings",
    logo: <TuneOutlinedIcon className="navbar-icon" />,
    label: "Call Setting",
  },
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const patientNavigation = [
  {
    to: "/patient-balance-dashboard",
    logo: <AttachMoneyIcon className="navbar-icon" />,
    label: "PATIENT BALANCE",
  },
  {
    to: "/patient-balance-reminders",
    logo: <NotificationsActiveIcon className="navbar-icon" />,
    label: "BALANCE REMINDERS",
  },
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const providerNavigation = [
  {
    to: "/dashboard",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "DASHBOARD",
  },
  {
    to: "/users",
    logo: <GroupIcon className="navbar-icon" />,
    label: "Users",
  },
  {
    to: "/calendar",
    logo: <CalendarTodayIcon className="navbar-icon" />,
    label: "CALENDER",
  },
  {
    to: "/dictation-summary",
    logo: <Description className="navbar-icon" />,
    label: "Dictation Summary",
  },
  {
    to: "/activity-logs",
    logo: <History className="navbar-icon" />,
    label: "Activity Logs",
  },
  {
    to: "/appointments",
    logo: <EventIcon className="navbar-icon" />,
    label: "APPOINTMENTS",
  },
  {
    to: "/claim-coding-optimization",
    logo: <AutoFixHigh className="navbar-icon" />,
    label: "Claim Coding Optimization",
  },
  {
    to: "/encounter-coding",
    logo: <Receipt className="navbar-icon" />,
    label: "Encounter Coding",
  },
  {
    to: "/patients",
    logo: <PersonIcon className="navbar-icon" />,
    label: "Patients",
  },
  {
    to: "/eligibility",
    logo: <ChecklistIcon className="navbar-icon" />,
    label: "Eligibility",
  },
  {
    to: "/appointments-count",
    logo: <EventNoteIcon className="navbar-icon" />,
    label: "APPOINTMENTS COUNT",
  },
  // {
  //   to: "/encounter-forms",
  //   logo: <PictureAsPdfIcon className="navbar-icon" />,
  //   label: "Encounter Forms",
  // },
  {
    to: "/patientMessage",
    logo: <MailOutlineIcon className="navbar-icon" />,
    label: "MESSAGE",
  },
  {
    to: "/search",
    logo: <SearchIcon className="navbar-icon" />,
    label: "SEARCH",
  },
  {
    to: "/support",
    logo: <HelpIcon className="navbar-icon" />,
    label: "Support",
  },
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const admingNavigation = [
  {
    to: "/manage-users",
    logo: <ManageAccountsIcon className="navbar-icon" />,
    label: "Users Management",
  },

  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const dictationArray = [
  {
    to: "/scribe-appointments",
    logo: <MicIcon className="navbar-icon" />,
    label: "Appointments",
  },
  {
    to: "/scribe-dashboard",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "Dictations",
  },
  {
    to: "/new-scribe-dictations",
    logo: <RecordVoiceOverIcon className="navbar-icon" />,
    label: "Dictations NEW*",
  },
  {
    to: "/care-management",
    logo: <VolunteerActivismOutlined className="navbar-icon" />,
    label: "Care Management",
  },
  {
    to: "/scriber-chat",
    logo: <Chat className="navbar-icon" />,
    label: "Scriber Chat",
  },
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const clinicalNavigation = [
  {
    to: "/clinical-care-dashboard",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "Dashboard",
  },
  {
    to: "/care-opportunity",
    logo: <LocalHospitalOutlinedIcon className="navbar-icon" />,
    label: "Care Opportunity",
  },
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const scribeNavigation = [
  {
    to: "/scribe-dashboard",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "Dashboard",
  },
  {
    to: "/scribe-appointments",
    logo: <MicIcon className="navbar-icon" />,
    label: "Appointments",
  },
  {
    to: "/patients",
    logo: <PersonIcon className="navbar-icon" />,
    label: "Patients",
  },
  {
    to: "/scribe-dictations",
    logo: <RecordVoiceOverIcon className="navbar-icon" />,
    label: "Dictations",
  },
  {
    to: "/new-scribe-dictations",
    logo: <RecordVoiceOverIcon className="navbar-icon" />,
    label: "Dictations NEW*",
  },
  {
    to: "/care-management",
    logo: <VolunteerActivismOutlined className="navbar-icon" />,
    label: "Care Management",
  },
  {
    to: "/scriber-chat",
    logo: <Chat className="navbar-icon" />,
    label: "Scriber Chat",
  },
  {
    to: "/scribe-dictations-summary",
    logo: <AssignmentIcon className="navbar-icon" />,
    label: "Dictations Summary",
  },
  {
    to: "/scribing-summary",
    logo: <Summarize className="navbar-icon" />,
    label: "Scribing Summary",
  },
  {
    to: "/claim-coding-optimization",
    logo: <AutoFixHigh className="navbar-icon" />,
    label: "Claim Coding Optimization",
  },
  {
    to: "/encounter-coding",
    logo: <Receipt className="navbar-icon" />,
    label: "Encounter Coding",
  },

  {
    to: "/scribe-add-doctor",
    logo: <AddToQueueIcon className="navbar-icon" />,
    label: "Add Doctor",
  },
  {
    to: "/ai-chat",
    logo: <Chat className="navbar-icon" />,
    label: "AI Chat",
  },

  {
    to: "/scribe-profile",
    logo: <AccountCircleIcon className="navbar-icon" />,
    label: "Profile",
  },
  {
    to: "/risk-adjustment-modeling",
    logo: <InsightsIcon className="navbar-icon" />,
    label: "Risk Adjustment Modeling",
  },
  {
    to: "/cpt-optimizer-tool",
    logo: <MedicalServicesIcon className="navbar-icon" />,
    label: "CPT Optimizer Tool",
  },
  {
    to: "/reports",
    logo: <AssessmentIcon className="navbar-icon" />,
    label: "Reports",
  },
  {
    to: "/scribe-help",
    logo: <HelpIcon className="navbar-icon" />,
    label: "Help",
  },
  {
    to: "/scribe-setting",
    logo: <SettingsIcon className="navbar-icon" />,
    label: "Setting",
  },
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const Navbar = (props) => {
  const location = useLocation();
  const userData = useUserData();
  const setUserData = useUpdateUserData();

  const handleLogout = () => {
    console.log("Logouit");
    window.location.reload();
    setUserData(null);
    logout();
  };

  if (userData?.userType === "clinical") {
    return (
      <nav
        className={`navbar ${props.collapsed ? "hide-navbar" : "show-navbar"}`}
      >
        <MdClose
          className="close-icon"
          onClick={() => props.setCollapsed(true)}
        />
        <ul>
          {clinicalNavigation.map((l) => {
            return (
              <li
                className={location.pathname === l.to ? "selected" : null}
                key={l.label}
              >
                {l.label !== "Logout" ? (
                  <Link className="link" to={l.to}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </Link>
                ) : (
                  <div className="link" onClick={handleLogout}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
  if (userData?.userType === "scribe") {
    return (
      <nav
        className={`navbar ${props.collapsed ? "hide-navbar" : "show-navbar"}`}
      >
        <MdClose
          className="close-icon"
          onClick={() => props.setCollapsed(true)}
        />
        <ul>
          {userData.user_details.user_role === "Provider"
            ? dictationArray.map((l) => {
                return (
                  <li
                    className={location.pathname === l.to ? "selected" : null}
                    key={l.label}
                  >
                    {l.label !== "Logout" ? (
                      <Link className="link" to={l.to}>
                        <span className="img">{l.logo}</span>
                        <span className="linkspan">{l.label}</span>
                      </Link>
                    ) : (
                      <div className="link" onClick={handleLogout}>
                        <span className="img">{l.logo}</span>
                        <span className="linkspan">{l.label}</span>
                      </div>
                    )}
                  </li>
                );
              })
            : scribeNavigation.map((l) => {
                return (
                  <li
                    className={location.pathname === l.to ? "selected" : null}
                    key={l.label}
                  >
                    {l.label !== "Logout" ? (
                      <Link className="link" to={l.to}>
                        <span className="img">{l.logo}</span>
                        <span className="linkspan">{l.label}</span>
                      </Link>
                    ) : (
                      <div className="link" onClick={handleLogout}>
                        <span className="img">{l.logo}</span>
                        <span className="linkspan">{l.label}</span>
                      </div>
                    )}
                  </li>
                );
              })}
        </ul>
      </nav>
    );
  } else if (userData?.userType === "provider") {
    return (
      <nav
        className={`navbar ${props.collapsed ? "hide-navbar" : "show-navbar"}`}
      >
        <MdClose
          className="close-icon"
          onClick={() => props.setCollapsed(true)}
        />
        <ul>
          {providerNavigation.map((l) => {
            return (
              <li
                className={location.pathname === l.to ? "selected" : null}
                key={l.label}
              >
                {l.label !== "Logout" ? (
                  <Link className="link" to={l.to}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </Link>
                ) : (
                  <div className="link" onClick={handleLogout}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  } else if (userData?.userType === "patient") {
    return (
      <nav
        className={`navbar ${props.collapsed ? "hide-navbar" : "show-navbar"}`}
      >
        <MdClose
          className="close-icon"
          onClick={() => props.setCollapsed(true)}
        />
        <ul>
          {patientNavigation.map((l) => {
            return (
              <li
                className={location.pathname === l.to ? "selected" : null}
                key={l.label}
              >
                {l.label !== "Logout" ? (
                  <Link className="link" to={l.to}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </Link>
                ) : (
                  <div className="link" onClick={handleLogout}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  } else if (userData?.userType === "admin") {
    return (
      <nav
        className={`navbar ${props.collapsed ? "hide-navbar" : "show-navbar"}`}
      >
        <MdClose
          className="close-icon"
          onClick={() => props.setCollapsed(true)}
        />
        <ul>
          {admingNavigation.map((l) => {
            return (
              <li
                className={location.pathname === l.to ? "selected" : null}
                key={l.label}
              >
                {l.label !== "Logout" ? (
                  <Link className="link" to={l.to}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </Link>
                ) : (
                  <div className="link" onClick={handleLogout}>
                    <span className="img">{l.logo}</span>
                    <span className="linkspan">{l.label}</span>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
  return (
    <nav
      className={`navbar ${props.collapsed ? "hide-navbar" : "show-navbar"}`}
    >
      <MdClose
        className="close-icon"
        onClick={() => props.setCollapsed(true)}
      />
      <ul>
        {callingNavigation.map((l) => {
          return (
            <li
              className={location.pathname === l.to ? "selected" : null}
              key={l.label}
            >
              {l.label !== "Logout" ? (
                <Link className="link" to={l.to}>
                  <span className="img">{l.logo}</span>
                  <span className="linkspan">{l.label}</span>
                </Link>
              ) : (
                <div className="link" onClick={handleLogout}>
                  <span className="img">{l.logo}</span>
                  <span className="linkspan">{l.label}</span>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navbar;
